import { addDays } from 'date-fns';
import { TimeIntervalTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

/**
 * Given the calendar day a period begins, return the calendar day it ends.
 * An overnight window finishes on the next day; all other windows finish on the same day.
 * Example: start May 5 → end May 6 (overnight) or end May 5 (hours/all-day).
 */
export function getDailyPeriodEndFromStartDay(
  startDay: Date,
  timeIntervalType: TimeIntervalTypeValues
): Date {
  if (timeIntervalType === TimeIntervalTypeValues.OVERNIGHT) {
    return addDays(startDay, 1);
  }

  return startDay;
}
